import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
	bold: {
		fontWeight: theme.typography.fontWeightBold,
	},
}));

export const SurgeonEventInfo: React.FC<{ bold?: boolean }> = ({ bold, children }) => {
	const classes = useStyles();
	return (
		<Typography
			variant="body2"
			className={classNames({
				[classes.bold]: bold,
			})}
		>
			{children}
		</Typography>
	);
};
